import { Injectable, Signal, computed } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';

import { mergeMap } from 'rxjs';

import { BetslipType } from '../../../../core/betslip-type';
import { SummaryErrorsViewModel } from '../../../validation/components/common/errors-container.component';
import { BetslipError } from '../../../validation/errors/betslip-error';
import { ErrorViewModelService } from '../../../validation/services/error-viewmodel.service';
import { isGroupOfferChangedError } from '../../../validation/services/utils/betslip-errors-utils';

@Injectable()
export class LinearComboModuleErrorViewModelService {
    constructor(private errorViewModelService: ErrorViewModelService) {}

    getErrorViewModel(
        errorsSignal: Signal<BetslipError[]>,
        hasComboPrevention: Signal<boolean>,
        betslipType: Signal<BetslipType>,
    ): Signal<SummaryErrorsViewModel> {
        const isOfferChanged = computed(() => errorsSignal().some(isGroupOfferChangedError));
        const filteredErrors = computed(() => this.filterErrors(errorsSignal()));

        const errorViewModels$ = toObservable(filteredErrors).pipe(mergeMap((errors) => this.errorViewModelService.getErrorViewModels$(errors)));

        const errorViewModels = toSignal(errorViewModels$);

        return computed(() => ({
            errors: errorViewModels() ?? [],
            isOfferChanged: isOfferChanged(),
            hasComboPrevention: hasComboPrevention(),
            betslipType: betslipType(),
        }));
    }

    private filterErrors(errors: BetslipError[]): BetslipError[] {
        return errors.filter((e) => !isGroupOfferChangedError(e));
    }
}
